import React from 'react';
import Dropdown from "react-bootstrap/Dropdown";
import { MenuItemType, NavObjectType, lddGlobalSessionInfo } from "../Components/navigationTypes";
import { Badge, InputGroupProps } from 'react-bootstrap';

function GenerateMenuItem(menuItem: MenuItemType, nav: (navObject: NavObjectType) => void) {
    const { label, id, labelStyle, navigate, icon, newBadge } = menuItem;

    return (
        <Dropdown.Item key={(id)?id:label} style={labelStyle ?? {}} onClick={() => nav(navigate)}>
            {icon &&
                <i className={icon} />
            }
            {label}
            {newBadge &&
                <Badge text="light" className="indicator-new-inline" pill>New</Badge>
            }
        </Dropdown.Item>
    )
}

interface CustomToggleProps extends InputGroupProps {
    iconClass: string;
}

const CustomToggle = React.forwardRef<HTMLInputElement, CustomToggleProps>(
    ({ children, onClick, iconClass }, ref) => (
        <i className={iconClass}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                // e.stopPropagation();
                onClick(e);
            }}>
            {children}
        </i>
    ))

type AddMenuProperties = {
    menuOptions: Array<MenuItemType>;
    nav: (navObject: NavObjectType) => void;
    SessionInfo: lddGlobalSessionInfo;
    iconType?: "ellipsis" | "default";
}
export const AddMenu = (props: AddMenuProperties) => {
    const { menuOptions, nav } = props;
    return (
        <Dropdown drop="end">
            <Dropdown.Toggle as={CustomToggle} iconClass={(props.iconType === "ellipsis" ? "fa-duotone fa-ellipsis-vertical" : "fa-solid  fa-circle-plus")}/>
            <Dropdown.Menu onClick={(e) => e.stopPropagation()}>
                <Dropdown.Header>
                {(props.iconType === "ellipsis" ? "Options" : "Add")}</Dropdown.Header>
                {menuOptions.map(option => GenerateMenuItem(option, nav))}
            </Dropdown.Menu>
        </Dropdown>
    )
}